export const programConfigs = {
    // -------------------------------------------------------------
    // 1. DAY REHAB PROGRAM
    // -------------------------------------------------------------
    DAY_REHAB_PROGRAM: {
        phases: [
            {
                id: 1,
                name: "Phase-01",
                forms: [
                    "Inquiry Form",
                    "Consent Form",
                ],
            },
            {
                id: 2,
                name: "Phase-02",
                forms: [
                    "Integrated Assessment Form",
                ],
            },
            {
                id: 3,
                name: "Phase-03",
                forms: [
                    "Exercise Schedule",
                    "Prescription Slip/Medication Sheet",
                    "CROS-3 Form",
                    "Individual Client File Form",
                    // Moved from Phase-04 -> now mandatory (Phase-03)
                    "Client Feedback & Discharge Interview",
                    "Discharge Summary",
                    "Discharge Advice",
                    "Individual Rehabilitation Plan",
                    "Family Meeting Minutes",
                    "Progress Notes Record (RPR)",
                    "Pros Form",
                ],
            },
            {
                id: 4,
                name: "Phase-04",
                forms: [
                    "Anxiety Form",
                    "BDI-II Form",
                    "Beck Suicide Intent Scale",
                    "BPRS Form",
                    "Depression Patient Health Question",
                    "Obsessive Compulsive Disorder Test",
                    "Qol2",
                    "YMRS Form",
                    // Moved from Phase-03 -> now optional (Phase-04)
                    "Client Movement Request Form",
                ],
            },
        ],
        formRoutes: {
            "Inquiry Form": "/inquiry",
            "Consent Form": "/consent",
            "Integrated Assessment Form": "/residential/phase-01/integrated-initial-assessment",
            "Individual Rehabilitation Plan": "/individual-rehab-plan-two",
            "Exercise Schedule": "/exercise-schedule",
            "Prescription Slip/Medication Sheet": "/phase05/medication-sheets",
            "Client Movement Request Form": "/phase03/escort-form",
            "CROS-3 Form": "/phase03/cros3-form",
            "Individual Client File Form": "/phase03/individual-client-file",
            "Anxiety Form": "/phase04/anxiety",
            "BDI-II Form": "/phase04/bdi",
            "Beck Suicide Intent Scale": "/phase04/suicide-intent",
            "BPRS Form": "/phase04/bprs",
            "Depression Patient Health Question": "/phase04/phq",
            "Discharge Advice": "/phase07/discharge-advice",
            "Client Feedback & Discharge Interview": "/phase04/client-feeback-discharge-interview",
            "Discharge Summary": "/phase07/discharge-summary",
            "Family Meeting Minutes": "/phase05/family-meeting-minutes",
            // "IRP (Individual Rehabilitation Plan)": "/phase05/individualised-rehab-plans",
            "Obsessive Compulsive Disorder Test": "/phase04/obsessive-compulsive-test",
            "Progress Notes Record (RPR)": "/phase05/progress-notes",
            "Pros Form": "/phase05/pros-assessments",
            "Qol2": "/phase04/qol",
            "YMRS Form": "/phase04/ymrs",
        },
    },

    // -------------------------------------------------------------
    // 2. HOME VISITATION PROGRAM
    // -------------------------------------------------------------
    HOME_VISITATION_PROGRAM: {
        phases: [
            {
                id: 1,
                name: "Phase-01",
                forms: [
                    "Inquiry Form",
                    "Consent Form",
                    "Escort Form",
                    "Home Visit Clinical Record Form",
                ],
            },
        ],
        formRoutes: {
            "Inquiry Form": "/inquiry",
            "Consent Form": "/consent",
            "Escort Form": "/home-visitation/escort-form",
            "Home Visit Clinical Record Form": "/home-visitation/clinical-record",
        },
    },

    // -------------------------------------------------------------
    // 3. RESIDENTIAL REHAB PROGRAM
    // -------------------------------------------------------------
    RESIDENTIAL_REHAB_PROGRAM: {
        phases: [
            {
                id: 1,
                name: "Phase-01",
                forms: [
                    "Inquiry Form",
                    "Consent Form",
                ],
            },
            {
                id: 2,
                name: "Phase-02",
                forms: [
                    "Integrated Assessment Form",
                ],
            },
            {
                id: 3,
                name: "Phase-03",
                forms: [
                    // DISCHARGE SUMMARY - 4 TYPES
                    "Discharge Summary (Psychiatric)",
                    "Discharge Summary (Physician)",
                    "Discharge Summary (Nursing)",
                    "Discharge Summary (PRPS)",

                    "Psych Order",

                    // PROGRESS NOTES - 2 TYPES
                    "Progress Notes Record (Psychiatric) - RPR",
                    // "Progress Notes Record (PRPS) - RPR",

                    "Progress Notes Record (Phsyician)[Sana]",
                    "ADL Record Sheet",
                    "Personal Belonging",
                    "CROS-3 Form",
                    "Progress Notes PRP",
                    "Individual Client File Form",
                    "Individual Rehabilitation Plan",
                    "Transition Form",
                    "Exercise Schedule",
                    "Nursing Record",
                    "Prescription Slip/Medication Sheet",
                    "Vitals Monitoring Chart",
                    "Family Meeting Minutes",
                    "Tentative Family Plan",
                    "Pros Form",
                    // Moved from Phase-04 -> now mandatory (Phase-03)
                    "Client Feedback Form",
                    "Family Feedback Form",
                ],
            },
            {
                id: 4,
                name: "Phase-04",
                forms: [
                    "Incident Report",
                    "Lama Policy",
                    "Referral Form",
                    "Relocation Policy",
                    "Safety Plan",
                    "Safety Plan (URDU)",
                    "Suicide Detail",
                    "Violence Detail",
                    // Moved from Phase-03 -> now optional (Phase-04)
                    "Client Movement Request Form",
                    "Complaint Form",
                    "LEAP Participation Consent Form",
                    "Escort Form [injection]",
                    "Depot injection Chart",
                    "Anxiety Form",
                    "BDI-II Form",
                    "Beck Suicide Intent Scale",
                    "BPRS Form",
                    "Depression Patient Health Question",
                    "Obsessive Compulsive Disorder Test",
                    "Qol2",
                    "YMRS Form",
                ],
            },
        ],
        formRoutes: {
            "Inquiry Form": "/inquiry",
            "Consent Form": "/consent",
            "Integrated Assessment Form": "/residential/phase-01/integrated-initial-assessment",

            // DISCHARGE SUMMARY - Same route, type_id will be passed in state
            "Discharge Summary (Psychiatric)": "/phase07/discharge-summary",
            "Discharge Summary (Physician)": "/phase07/discharge-summary",
            "Discharge Summary (Nursing)": "/phase07/discharge-summary",
            "Discharge Summary (PRPS)": "/phase07/discharge-summary",
            "Psych Order": "/phase03/psychiatrist-order",

            // PROGRESS NOTES - Same route, type_id will be passed in state
            "Progress Notes Record (Psychiatric) - RPR": "/phase05/progress-notes",
            // "Progress Notes Record (PRPS) - RPR": "/phase05/progress-notes",

            "Progress Notes Record (Phsyician)[Sana]": "/phase05/sana-notes",
            "ADL Record Sheet": "/phase05/adl-record-sheet",
            "Personal Belonging": "/phase04/personal-belongings",
            "Complaint Form": "/phase03/complaint-form",
            "Escort Form [injection]": "/injections",
            "Client Movement Request Form": "/phase03/escort-form",
            "CROS-3 Form": "/phase03/cros3-form",
            "Progress Notes PRP": "/phase03/progress-notes-prp",
            "Individual Client File Form": "/phase03/individual-client-file",
            "Individual Rehabilitation Plan": "/individual-rehab-plan-two",
            "LEAP Participation Consent Form": "/phase03/leap-participation-consent",
            "Transition Form": "/phase03/transition-form",
            "Exercise Schedule": "/exercise-schedule",
            "Nursing Record": "/phase05/nursing-records",
            "Depot injection Chart": "/phase05/depot-injections",
            "Prescription Slip/Medication Sheet": "/phase05/medication-sheets",
            "Vitals Monitoring Chart": "/phase05/vitals-monitor",
            "Anxiety Form": "/phase04/anxiety",
            "BDI-II Form": "/phase04/bdi",
            "Beck Suicide Intent Scale": "/phase04/suicide-intent",
            "BPRS Form": "/phase04/bprs",
            "Depression Patient Health Question": "/phase04/phq",
            "Family Meeting Minutes": "/phase05/family-meeting-minutes",
            // "IRP (Individual Rehabilitation Plan)": "/phase05/individualised-rehab-plans",
            "Obsessive Compulsive Disorder Test": "/phase04/obsessive-compulsive-test",
            "Qol2": "/phase04/qol",
            "Tentative Family Plan": "/phase04/tentative-family-plan",
            "Pros Form": "/phase05/pros-assessments",
            "YMRS Form": "/phase04/ymrs",

            "Incident Report": "/phase05/incident-report",
            "Lama Policy": "/residential/optional/lama-form",
            "Referral Form": "/residential/optional/referral-form",
            "Relocation Policy": "/residential/optional/relocation-form",
            "Safety Plan": "/residential/optional/safety-plan",
            "Safety Plan (URDU)": "/residential/optional/safety-plan-urdu",
            "Suicide Detail": "/residential/optional/suicide-detail",
            "Violence Detail": "/residential/optional/violence-risk",
            "Client Feedback Form": "/phase04/client-feedback",
            "Family Feedback Form": "/phase04/family-feedback",
        },
    },
};